import React, { Component } from "react";

import PropTypes from "prop-types";

import PrismaEditor from "@prisma-cms/editor";

export default class ModxclubEditor extends Component {


  static propTypes = {
    content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    inEditMode: PropTypes.bool.isRequired,
  }


  static defaultProps = {
    inEditMode: false,
  }


  render() {

    let {
      content: value,
      inEditMode,
      allow_edit,
      fullView,
      // onChange,
      ...other
    } = this.props;

    // return null;

    if (!value || Array.isArray(value)) {
 
      value = undefined;
    }

    // console.log("value", typeof value, value);

    return <PrismaEditor
      value={value}
      readOnly={!inEditMode}
      // onChange={(rawContent, state) => {

      //   console.log("onChange", rawContent, state);

      //   return;

      //   return onChange && onChange(state, rawContent);
      // }}
      {...other}
    />;
  }
}